import { actions } from './actions';
import { state } from './state';
import { mutations } from './mutations';

const getters = {
};

const slack = {
  moduleName: 'version',
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default slack;
